export default __webpack_public_path__ + "static/media/TV4.dadb6f53.mp4";